// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Steps from "@store/Library/Components/Bunzl/Steps/Steps";
import FadeIn from "@store/Library/Components/Reporting/Common/FadeIn";
import CardComponent from "@store/Library/Widgets/Card/Card";
import CardBodyComponent from "@store/Library/Widgets/Card/CardBody";
import CardHeaderComponent from "@store/Library/Widgets/Card/CardHeader";
import { useCreditFormContext } from "@store/Library/Widgets/CreditForm/CreditFormContextContainer";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

import React from "react";
import { css } from "styled-components";

enum fields {
    vertical = "vertical",
}
interface CreditFormProps extends WidgetProps {
    [fields.vertical]?: boolean;
}

interface CreditFormStyles {
    wrapper?: InjectableCss;
}

interface CreditFormStepStyles {
    cardComponentStyles?: InjectableCss;
    cardBodyStyles?: InjectableCss;
}
const creditFormStepStyles: CreditFormStepStyles = {
    cardBodyStyles: {
        css: css`
            position: sticky;
            top: 0;
        `,
    },
    cardComponentStyles: {
        css: css`
            position: relative;
            background-color: ${getColor("secondary.light")};
            border-top-left-radius: ${pxToRem(12)};
            border-top-right-radius: 0;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: ${pxToRem(12)};
            height: 100%;
        `,
    },
};
const CreditFormSteps: React.FC<CreditFormProps> = ({ vertical = true }) => {
    const creditFormContext = useCreditFormContext();
    const { steps, currentStep, setCurrentStep } = creditFormContext;
    const stepsComplete = useAppSelector(state => {
        const form = state.bunzl.pages.stepForm?.creditForm;
        return form?.steps.map(step => {
            return { valid: step.valid, percentageComplete: step.percentComplete };
        });
    });

    const stepsWithComplete = steps.map((step, index) => {
        return {
            ...step,
            complete: stepsComplete?.[index]?.valid,
            percentageComplete: stepsComplete?.[index]?.percentageComplete,
        };
    });
    return (
        <FadeIn appear animate duration={100}>
            <CardComponent extendedStyles={creditFormStepStyles.cardComponentStyles} variant="unstyled" size="large">
                <CardHeaderComponent>
                    <Typography as="h2" variant="h2">
                        {translate("Credit Form")}
                    </Typography>
                </CardHeaderComponent>

                <CardBodyComponent extendedStyles={creditFormStepStyles.cardBodyStyles}>
                    <Steps
                        steps={stepsWithComplete}
                        currentStep={currentStep}
                        vertical={vertical}
                        setCurrentStep={setCurrentStep}
                        title="Test Steps"
                    />
                </CardBodyComponent>
            </CardComponent>
        </FadeIn>
    );
};

const widgetModule: WidgetModule = {
    component: CreditFormSteps,
    definition: {
        group: "Common",
        displayName: "Credit Form Steps",
        fieldDefinitions: [
            {
                name: fields.vertical,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
